import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { push } from 'connected-react-router';
import Success from '@components/success';

const LabelDeleteSuccessPage = () => {
  const dispatch = useDispatch();
  return (
    <Success
      HEADING={'SUCCESS.LABEL.HEADING'}
      DESCRIPTION={'SUCCESS.LABEL.DESCRIPTION'}
      CONTINUE={'SUCCESS.LABEL.RESTORE.CONTINUE'}
      continueTo={() => dispatch(push(`/label`))}
    />
  );
};

export default styled(LabelDeleteSuccessPage)`
  margin-top: 40px;
  padding-bottom: 200px;

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    margin-top: 80px;
  }
`;
